import { render } from "./Protocols.vue?vue&type=template&id=bae45548"
import script from "./Protocols.vue?vue&type=script&lang=js"
export * from "./Protocols.vue?vue&type=script&lang=js"

import "./Protocols.vue?vue&type=style&index=0&id=bae45548&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__